/**
 * This file was copied from dashboard into clowncar as part of a cleanup effort
 */
import { IconLogoTock } from '@tock/icons';
import { css } from '@emotion/react';
import BaseComponent from '@tock/shared/components/BaseComponent';
import LoadingBarContainer from 'components/LoadingBarContainer';

interface Props {
  footer?: string | JSX.Element;
  isLoading: boolean;
  spinnerText?: string;
  title?: string | JSX.Element;
}

const tockLogo = css`
  font-size: 12rem;
`;

class Panel extends BaseComponent<React.PropsWithChildren<Props>> {
  render() {
    const { children, footer, title, isLoading, spinnerText } = this.props;

    return (
      <div className="Panel">
        {title && <span className="Panel-title">{title}</span>}
        <LoadingBarContainer
          containerClassName="Panel-content"
          isLoading={isLoading}
          spinnerClassName="Panel-spinner"
          spinnerText={spinnerText}
        >
          <header className="Panel-header">
            <IconLogoTock css={tockLogo} data-testid="tock-logo" />
          </header>

          <div className="Panel-body">{children}</div>

          {footer && <footer className="Panel-footer">{footer}</footer>}
        </LoadingBarContainer>
      </div>
    );
  }
}

export default Panel;
